export default "__VITE_ASSET__DUa6ZsJ$__"